import React, { useState, useEffect } from 'react'
import { Route, Router, Switch, NavLink } from 'react-router-dom';
import Cart from './Cart';
import Products from './Products';
import './Shop.css'

const PAGE_PRODUCTS = 'products';
const PAGE_CART ='cart';



function Shop({cart, setCart}) {

    
    const [page, setPage] = useState('products');

    const onAdd = (product) => {
    const exist = cart.find((x) => x.id === product.id);
    if (exist) {
      setCart(
        cart.map((x) =>
          x.id === product.id ? { ...exist, qty: exist.qty + 1 } : x
        )
      );
    } else {
      setCart([...cart, { ...product, qty: 1 }]);
    }}

    const onRemove = (product) => {
        const exist = cart.find((x) => x.id === product.id);
        if (exist.qty === 1) {
          setCart(cart.filter((x) => x.id !== product.id));
        } else {
          setCart(
            cart.map((x) =>
              x.id === product.id ? { ...exist, qty: exist.qty - 1 } : x
            )
          );
        }
      };

    //Adding/Removing without quantity (old methods, items don't stack)
    /*const addToCart = (product) => {
        product.qty +=1 ;
        setCart([...cart, {...product}]);
    };
    const removeFromCart = (productToRemove) => {
        setCart(cart.filter((product) => product !== productToRemove))
    }

    //Old navigation method
    const navigateTo = (nextPage) => {
        setPage(nextPage);
    };*/
    

    return (
        <div>

                <Switch>
                    <Route exact path="/shop" >
                        <div>
                <header>
                <NavLink to="/shop/cart"><button >Go to Cart ({cart.length})</button></NavLink>

                
                </header>
                <Products onAdd={onAdd} /></div>
                    </Route>
                    </Switch>
                    <Switch>
                    <Route exact path="/shop/cart" >
                    <div>
                <header>
        
    
                <NavLink to="/shop" ><button>View Products</button></NavLink>
                </header>
                <Cart cart={cart} onAdd={onAdd} onRemove={onRemove}/></div>
                    </Route>
                    </Switch>
                    
                

            
            {/*page === PAGE_PRODUCTS && 
            */}
      
           {/* <div>
                <h3>Black Shirt</h3>
                <h4>$20.00</h4>
                <img src="https://hips.hearstapps.com/vader-prod.s3.amazonaws.com/1621283126-t-shirts-buckmason-black-slub-1621282639.jpg"/>
                <button>Add To Cart</button>
            </div>
            <div>
                <h3>Blue Shirt</h3>
                <h4>$20.00</h4>
                <img src="https://www.rei.com/media/product/140889"/>
                <button>Add To Cart</button>
           </div>*/}
            
        </div>
    )
}

export default Shop
